// frontend/src/pages/Country/Country.jsx
import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Globe, Plus } from "lucide-react";
import "./Country.css";

// ✅ Backend base URL — same pattern as Banktype.jsx
const url = process.env.REACT_APP_BACKEND_URL;

// ✅ Helper: build auth header from localStorage token
const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const Country = () => {
  const [data, setData] = useState({ name: "" });
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => setData({ name: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!data.name.trim()) return toast.error("Country name is required");

    setSubmitting(true);
    try {
      await axios.post(`${url}/api/country`, data, {
        headers: getAuthHeaders(),
      });
      toast.success("Country added successfully!");
      navigate("/ViewCountry");
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to add country");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="form-wrapper">
      <div className="country-form-container">
        <h2><Globe size={20} /> Add New Country</h2>
        <form className="country-form" onSubmit={handleSubmit}>
          <div className="form-field filled">
            <input
              type="text"
              value={data.name}
              onChange={handleChange}
              placeholder="Enter country name"
              required
            />
            <label>Country Name *</label>
          </div>
          <button type="submit" className="submit-btn" disabled={submitting}>
            {submitting ? "Processing..." : "Add Country"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Country;